import type { HeaderConfig } from '../../header.types.ts';

const headerConfig: HeaderConfig = {
  showsInfoBanner: false,
  showsSearch: false,
};

export { headerConfig };
